import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "task-list-app" }
const _hoisted_2 = { id: "text-numeric-display" }
const _hoisted_3 = { id: "text-numeric-display" }
const _hoisted_4 = { id: "text-numeric-display" }
const _hoisted_5 = { id: "text-numeric-display" }
const _hoisted_6 = { id: "text-numeric-display" }
const _hoisted_7 = { id: "text-numeric-display" }
const _hoisted_8 = { id: "text-numeric-display" }
const _hoisted_9 = { id: "text-numeric-display" }
const _hoisted_10 = { id: "text-numeric-display" }
const _hoisted_11 = { id: "text-numeric-display" }
const _hoisted_12 = { class: "tasks" }
const _hoisted_13 = { id: "text-numeric-display" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { id: "text-numeric-display" }
const _hoisted_16 = { id: "text-numeric-display" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { id: "text-numeric-display" }
const _hoisted_19 = { id: "text-numeric-display" }
const _hoisted_20 = { id: "text-numeric-display" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { id: "text-numeric-display" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { key: 6 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ve_progress = _resolveComponent("ve-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode(" Level: ")),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getCurrentLevel.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[1] || (_cache[1] = _createTextVNode(" XP: ")),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getCurrentXp.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[2] || (_cache[2] = _createTextVNode(" Daily Streak: ")),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getCurrentDailyStreak.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[3] || (_cache[3] = _createTextVNode(" Tasks Completed Today: ")),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getCurrentTasksCompletedToday.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[4] || (_cache[4] = _createTextVNode(" Total Tasks Completed: ")),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getCurrentTotalTasksCompleted.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[5] || (_cache[5] = _createTextVNode(" Score: ")),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getCurrentScore.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[6] || (_cache[6] = _createTextVNode(" Days Completed: ")),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.getDaysCompleted.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[7] || (_cache[7] = _createTextVNode(" Best Points Earned After Completing the Task: ")),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getCurrentBestScoreEarned.toLocaleString("en-US")), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[8] || (_cache[8] = _createTextVNode(" Rating: ")),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getCurrentRating.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })), 1)
    ]),
    _createVNode(_component_ve_progress, { progress: _ctx.getCurrentProgress }, {
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createTextVNode("Level ")),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getCurrentLevel.toLocaleString("en-US")), 1)
      ]),
      _: 1
    }, 8, ["progress"]),
    _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Task list", -1)),
    _createElementVNode("ul", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTasks, (task) => {
        return (_openBlock(), _createElementBlock("li", {
          key: task.newId,
          class: "task"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass({
            overdue: new Date(task.dueDate + ' 23:59:59.999') < new Date(),
          })
          }, [
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode(_toDisplayString(task.task), 1),
              (new Date(task.dueDate + ' 23:59:59.999') < new Date())
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (Overdue)"))
                : _createCommentVNode("", true)
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
            _cache[11] || (_cache[11] = _createTextVNode("Streak: ")),
            _createElementVNode("span", _hoisted_15, _toDisplayString(task.streak.toLocaleString("en-US")), 1),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _cache[13] || (_cache[13] = _createTextVNode("Rank: ")),
            _createElementVNode("span", _hoisted_16, _toDisplayString(task.rank.toLocaleString("en-US")), 1),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("progress", {
              max: "100",
              value: task.rankProgress
            }, null, 8, _hoisted_17),
            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
            _cache[16] || (_cache[16] = _createTextVNode("Due date: ")),
            _createElementVNode("span", _hoisted_18, _toDisplayString(task.dueDate), 1),
            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
            _cache[18] || (_cache[18] = _createTextVNode("Priority: ")),
            _createElementVNode("span", _hoisted_19, _toDisplayString(task.priority), 1),
            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
            _cache[20] || (_cache[20] = _createTextVNode("Difficulty: ")),
            _createElementVNode("span", _hoisted_20, _toDisplayString(task.difficulty), 1),
            _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
            _cache[22] || (_cache[22] = _createTextVNode("Repeat: ")),
            (task.repeatInterval != 5)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(task.repeatEvery.toLocaleString("en-US")), 1)
                ]))
              : _createCommentVNode("", true),
            _cache[23] || (_cache[23] = _createTextVNode(" ")),
            (task.repeatInterval == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Day"))
              : _createCommentVNode("", true),
            (task.repeatInterval == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Week"))
              : _createCommentVNode("", true),
            (task.repeatInterval == 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Month"))
              : _createCommentVNode("", true),
            (task.repeatInterval == 4)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Year"))
              : _createCommentVNode("", true),
            (task.repeatInterval == 5)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Once"))
              : _createCommentVNode("", true),
            (task.repeatEvery > 1 && task.repeatInterval != 5)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "s"))
              : _createCommentVNode("", true)
          ], 2),
          (!task.isCompleted)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: ($event: any) => (_ctx.completeTask(task.newId))
              }, " Complete ", 8, _hoisted_29))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.deleteTask(task.newId))
          }, "Delete", 8, _hoisted_30),
          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1))
        ]))
      }), 128))
    ])
  ]))
}